export default __webpack_public_path__ + "static/media/15.bf0eec9b.jpg";